export const ViewFileModelProps = {
  /**是否显示 */
  visible: {
    type: Boolean,
    default: false,
  },
  /**
   * 获取文件信息的promise函数,返回值为
   * @description
   * {
   * @param fileName, 文件名
   * @param filetype, 文件类型
   * @param fileBlob, 文件流
   * }
   */
  getFileInfo: {
    type: Function,
  },
  filePath: {
    type: String,
  },
};

/**
 * 使用实例
 * const getFileInfo = async ()=>{
 * const res = await axios.get("/api/xxxx/xxxxxxx");
 * const fileName = UtilFile.getFileNameByResHeader(res.headers)
 * const filetype = UtilFile.getFileTypeByName(fileName);
 * const fileBlob =res.data ;
 * return {
 *    fileName,filetype,fileBlob
 *   }
 * }
 * 
 * <base-ViewFileModel
      :visible="showModel"
      :getFileInfo = "getFileInfo"
      @close="showModel = false"
    />
 *
 */
